// import React from "react";
// import "./Invoice.css";

// const Invoice = ({ invoiceDetails, invoiceDetailsProduct }) => {
//   console.log("invoiceDetailsProduct", invoiceDetailsProduct);
//   console.log("invoiceDetails", invoiceDetails);

//   return (
//     <div className="invoice-root">
//       <header className="invoice-header">
//         <div className="invoice-hero">
//           <div className="invoice-hero-overlay">
//             <h1 className="invoice-title">فاکتور</h1>
//             <div className="invoice-dates">
//               <div className="date-row"><span>تاریخ فاکتور:</span> <strong>{invoiceDetails.date_created}</strong></div>
//             </div>
//           </div>
//         </div>
//       </header>
//       <section className="invoice-meta">
//         <div className="meta-label-title">
//           <h2>ویزیتور</h2>
//         </div>

//         <div className="meta-card">
//           <div className="meta-item">
//             <div className="meta-label">صادر شده از:</div>
//             <div className="meta-value big">{invoiceDetails.marketer_name}</div>
//           </div>

//           <div className="meta-item">
//             {/* فیلد خالی */}
//           </div>

//           <div className="meta-item">
//             <div className="meta-label">تلفن:</div>
//             <div className="meta-value">{invoiceDetails.marketer_phone_number}</div>
//           </div>
//         </div>
//       </section>

//       <section className="invoice-meta">
//         <div className="meta-label-title">
//           <h2>فروشنده</h2>
//         </div>
//         <div className="meta-card">
//           <div className="meta-item">
//             <div className="meta-label">صادر شده برای:</div>
//             <div className="meta-value big"> {invoiceDetails.seller_name} | {invoiceDetails.seller_shop_name}
//             </div>
//           </div>

//           <div className="meta-item">
//             <div className="meta-label">آدرس:</div>
//             <div className="meta-value">{invoiceDetails.seller_address}</div>
//           </div>

//           <div className="meta-item">
//             <div className="meta-label">تلفن:</div>
//             <div className="meta-value">{invoiceDetails.seller_phone_number} - {invoiceDetails.seller_landline_number}</div>
//           </div>
//         </div>
//       </section>





//       <main className="invoice-main">
//         <table className="invoice-table" cellSpacing="0" cellPadding="0">
//           <thead>
//             <tr>
//               <th>شرح آیتم</th>
//               <th>تعداد</th>
//               <th>قیمت</th>
//               <th>مبلغ</th>
//             </tr>
//           </thead>
//           <tbody>
//             {invoiceDetailsProduct && invoiceDetailsProduct.length > 0 ? (
//               invoiceDetailsProduct.map((item, index) => (
//                 <tr key={index}>
//                   <td>{item.product_name} {item.product_category} {item.product_brand}</td>
//                   <td>{Number(item.product_quantity).toLocaleString("fa-IR")}</td>
//                   <td>{Number(item.selling_price).toLocaleString("fa-IR")}</td>
//                   <td>{Number(item.product_total_price).toLocaleString("fa-IR")}</td>

//                   {/* <td>
//                     {(
//                       Number(item.product_quantity) * Number(item.product_price)
//                     ).toLocaleString("fa-IR")}
//                   </td> */}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4" style={{ textAlign: "center" }}>
//                   هیچ محصولی ثبت نشده است
//                 </td>
//               </tr>
//             )}
//           </tbody>

//         </table>


//         <aside className="invoice-summary">
//          <div className="payment-details">
//   <h4>جزئیات پرداخت</h4>

//   {invoiceDetails.payment_cash > 0 && (
//     <p>
//       <strong>پرداخت نقدی:</strong> {invoiceDetails.payment_cash}{" "}
//       {invoiceDetails.payment_cash_price && ` (قیمت: ${invoiceDetails.payment_cash_price}) `}
//       {invoiceDetails.payment_cash_desc && `– توضیح: ${invoiceDetails.payment_cash_desc}`}
//     </p>
//   )}

//   {invoiceDetails.payment_cheque > 0 && (
//     <p>
//       <strong>پرداخت چکی:</strong> {invoiceDetails.payment_cheque}{" "}
//       {invoiceDetails.payment_cheque_price && ` (قیمت: ${invoiceDetails.payment_cheque_price}) `}
//       {invoiceDetails.payment_cheque_desc && `– توضیح: ${invoiceDetails.payment_cheque_desc}`}
//     </p>
//   )}

//   {invoiceDetails.payment_other > 0 && (
//     <p>
//       <strong>پرداخت دیگر:</strong> {invoiceDetails.payment_other}{" "}
//       {invoiceDetails.payment_other_price && ` (قیمت: ${invoiceDetails.payment_other_price}) `}
//       {invoiceDetails.payment_other_desc && `– توضیح: ${invoiceDetails.payment_other_desc}`}
//     </p>
//   )}
// </div>



//           {/* <div className="totals">
//             <div className="totals-row"><span>جمع جزء</span><strong>۱۱۰.۰۰۰$</strong></div>
//             <div className="totals-row"><span>مالیات (۱۰٪)</span><strong>۱۱.۰۰۰$</strong></div>
//             <div className="totals-row total"><span>مبلغ کل</span><strong>۱۲۱.۰۰۰$</strong></div>
//           </div> */}
//         </aside>
//       </main>


//     </div>
//   );





// };

// export default Invoice;



import React from "react";
import "./Invoice.css";

import PrimaryBurron from "../Button/primaryButton/PrimaryButton"




import jsPDF from "jspdf";
import html2canvas from "html2canvas";




function toShamsiDateTime(dateTimeString) {
  const date = new Date(dateTimeString);

  const gy = date.getFullYear();
  const gm = date.getMonth() + 1;
  const gd = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const g_d_m = [0,31,59,90,120,151,181,212,243,273,304,334];
  let gy2 = (gm > 2) ? (gy + 1) : gy;
  let days = 355666 + (365 * gy) + Math.floor((gy2 + 3) / 4)
             - Math.floor((gy2 + 99) / 100) + Math.floor((gy2 + 399) / 400)
             + gd + g_d_m[gm - 1];
  let jy = -1595 + (33 * Math.floor(days / 12053));
  days %= 12053;
  jy += 4 * Math.floor(days / 1461);
  days %= 1461;
  if (days > 365) {
    jy += Math.floor((days - 1) / 365);
    days = (days - 1) % 365;
  }
  let jm = (days < 186) ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
  let jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));

  // اعداد فارسی
  const toFaNum = (num) => num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

  // دو رقمی کردن قبل از تبدیل به فارسی
  const pad = (n) => n.toString().padStart(2, '0');

  return `${toFaNum(jy)}/${toFaNum(pad(jm))}/${toFaNum(pad(jd))} - ${toFaNum(pad(hours))}:${toFaNum(pad(minutes))}:${toFaNum(pad(seconds))}`;
}






const Invoice = ({ invoiceDetails, invoiceDetailsProduct }) => {
  const handlePrint = () => {
    const printContents = document.querySelector(".invoice").innerHTML;
    const printWindow = window.open("", "", "height=800,width=900");

    printWindow.document.write(`
    <html lang="fa" dir="rtl">
      <head>
        <title>پرینت فاکتور</title>
        <style>
         /* ====== تنظیمات پایه ====== */
body {
  font-family: vasir;
  margin: 20px;
  line-height: 1.6;
  color: #000;
  background: #fff;
  font-size: 14px;
}

h1, h2, h3, h4, h5 {
  margin: 0 0 10px 0;
  font-weight: bold;
  color: #222;
}

/* ====== جدول فاکتور ====== */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
  font-size: 13px;
}
th, td {
  border: 1px solid #ccc;
  padding: 8px 10px;
  text-align: right;
}
th {
  background: #f9f9f9;
  font-weight: bold;
}

/* ====== کارت‌ها ====== */
.cards-row {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.card22 {
  flex: 1;
  border: 1px solid #ccc;
  padding: 12px;
  margin: 0 6px;
  border-radius: 6px;
  background: #fafafa;
  font-size: 13px;
}
.label-cards {
  font-weight: bold;
  display: block;
  margin-bottom: 6px;
  color: #333;
}

/* ====== جمع کل و پرداخت ====== */
.summary {
  margin-top: 25px;
  border-top: 2px solid #000;
  padding-top: 12px;
}
.summary .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-weight: bold;
  font-size: 14px;
}
.payment-details {
  margin-top: 12px;
  font-size: 13px;
}
.payment-item {
  margin-bottom: 6px;
}

/* ====== چاپ ====== */
.invoice-print-btn-container {
  display: none;
}

        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };



   const handleSharePDF = async () => {
    try {
      const invoiceElement = document.querySelector(".invoice");

      // گرفتن تصویر از کل فاکتور
      const canvas = await html2canvas(invoiceElement, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      // ساخت PDF
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      // ذخیره PDF به صورت Blob
      const pdfBlob = pdf.output("blob");

      // اشتراک‌گذاری PDF در موبایل
      if (navigator.canShare && navigator.canShare({ files: [new File([pdfBlob], "invoice.pdf", { type: "application/pdf" })] })) {
        await navigator.share({
          files: [new File([pdfBlob], "invoice.pdf", { type: "application/pdf" })],
          title: `فاکتور شماره ${invoiceDetails.invoice_number}`,
          text: "فاکتور شما",
        });
      } else {
        // دانلود PDF به صورت fallback
        pdf.save(`invoice-${invoiceDetails.invoice_number}.pdf`);
      }
    } catch (err) {
      console.error("خطا در تولید یا اشتراک‌گذاری PDF:", err);
    }
  };
  

  return (
    <div className="invoice-wrap">
  <div className="invoice-top">

  {/* Wrapper برای details + print button */}
  <div className="invoice-details-print">
    <div className="invoice-details">
      <div className="invoice-col">
        <div className="label">شماره فاکتور:</div>
        <div className="value">{invoiceDetails.invoice_number}</div>
      </div>
      <div className="invoice-col">
        <div className="label">تاریخ فاکتور:</div>
        <div className="value">  {toShamsiDateTime(invoiceDetails.date_created)}
</div>
      </div>
      <div className="invoice-col">
        <div className="label">توضیحات فاکتور:</div>
        <div className="value">{invoiceDetails.invoice_desc}</div>
      </div>
    </div>

    <div className="invoice-print-btn-container">
      <PrimaryBurron onClick={handlePrint} title="پرینت فاکتور" fullWidth/>

      <div className="invoice-share-btn-container">
          <PrimaryBurron onClick={handleSharePDF} title="اشتراک‌گذاری PDF" fullWidth/>
        </div>

    </div>
  </div>
</div>


      <div className="invoice">

        <div className="dashboard-container">


          <div className="cards-row">

            <div className="card22 right-card">
              <span className="label-cards">ویزیتور</span>
              <div className="header">
              </div>
              <div className="content">
                <div className="support-title">
                  {invoiceDetails.marketer_name}  {invoiceDetails.marketer_surname} 

                </div>
                <div className="phone">{invoiceDetails.marketer_phone_number}</div>
                <div className="address">
                  تهران، خیابان قائم مقام، باین تر از مظفری،<br />
                  کوچه مکملیا
                </div>

              </div>
            </div>
            {/* بخش وسط - شرکت ساختمان هال ایرانیان */}
            <div className="card22 middle-card">
              <span className="label-cards">فروشگاه</span>
              <div className="header33">
              </div>
              <div className="content">
                <div className="company-name">
                  {invoiceDetails.seller_name} {invoiceDetails.seller_surname} - {invoiceDetails.seller_shop_name}

                </div>
                <div className="contact-info">
                  {invoiceDetails.seller_phone_number}
                  <br />
                  {invoiceDetails.seller_landline_number}

                </div>
                <div className="address">
                  {invoiceDetails.seller_province}, {invoiceDetails.seller_city}, {invoiceDetails.seller_address}
                  <br />
                </div>
              </div>
            </div>


            <div className="card22 left-card">
              <span className="label-cards">مبلغ کل</span>
              <div className="header">
              </div>
              <div className="content">
                <div className="amount">{(
                  Number(invoiceDetails.total_price)
                ).toLocaleString("fa-IR")} تـومان</div>
              </div>
            </div>



          </div>






          <div style={{ flex: 1 }}>
            <div className="table-container">
              <table className="table">
                <thead>
                  <tr>
                    <th >ردیف</th>
                    <th >نام محصول</th>
                    <th>تعداد جزء</th>
                    <th >مبلغ واحد</th>
                    <th >مبلغ کل </th>

                  </tr>
                </thead>
                <tbody>
                  {invoiceDetailsProduct && invoiceDetailsProduct.length > 0 ? (
                    invoiceDetailsProduct.map((item, index) => (
                      <tr key={index}>
                        <td >{index + 1}</td>

                        <td>{item.product_name} {item.product_category} {item.product_brand}</td>
                        <td>{Number(item.product_quantity).toLocaleString("fa-IR")}</td>
                        <td>{Number(item.selling_price).toLocaleString("fa-IR")}</td>
                        <td>{Number(item.product_total_price).toLocaleString("fa-IR")}</td>

                        {/* <td>
                    {(
                      Number(item.product_quantity) * Number(item.product_price)
                    ).toLocaleString("fa-IR")}
                  </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        هیچ محصولی ثبت نشده است
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

          
            </div>
          </div>
    {/* Summary */}
              <div className="summary">
                <div className="row">
                  <div>جمع کل :</div>
                  <div className="total">
                    {(
                      Number(invoiceDetails.total_price)
                    ).toLocaleString("fa-IR")}</div>
                </div>

                <div className="payment-details">
                  <h4>جزئیات پرداخت</h4>

                  {invoiceDetails.payment_cash > 0 && (
                    <div className="payment-item">
                      <strong>پرداخت نقدی: {(
                        Number(invoiceDetails.payment_cash_price)
                      ).toLocaleString("fa-IR")}</strong>

                      {invoiceDetails.payment_cash_desc && (
                        <div>توضیح: {invoiceDetails.payment_cash_desc}</div>
                      )}
                    </div>
                  )}

                  {invoiceDetails.payment_cheque > 0 && (
                    <div className="payment-item">
                      <strong>پرداخت چکی: {(
                        Number(invoiceDetails.payment_cheque_price)
                      ).toLocaleString("fa-IR")}</strong>

                      {invoiceDetails.payment_cheque_desc && (
                        <div>توضیح: {invoiceDetails.payment_cheque_desc}</div>
                      )}
                    </div>
                  )}

                  {invoiceDetails.payment_other > 0 && (
                    <div className="payment-item">
                      <strong>پرداخت نسیه: {(
                        Number(invoiceDetails.payment_other_price)
                      ).toLocaleString("fa-IR")}</strong>

                      {invoiceDetails.payment_other_desc && (
                        <div>توضیح: {invoiceDetails.payment_other_desc}</div>
                      )}
                    </div>
                  )}
                </div>





              </div>
        </div>

        {/* <div className="invoice-container">
          <div className="invoice-card">

            <div className="invoice-company">
              <p>فروشگاه</p>
              <div className="company-name">
                {invoiceDetails.seller_name} - {invoiceDetails.seller_shop_name}
              </div>
              <div className="company-location">
                {invoiceDetails.seller_landline_number}
              </div>
              <div className="company-location">
                {invoiceDetails.seller_phone_number}
              </div>
              <div className="company-location">
                {invoiceDetails.seller_province}, {invoiceDetails.seller_city}, {invoiceDetails.seller_address}
              </div>

            </div>

            <div className="invoice-company">
              <p>ویزیتور</p>
              <div className="company-name">{invoiceDetails.marketer_name}</div>
              <div className="company-location">{invoiceDetails.marketer_phone_number}</div>
            </div>

            <div className="invoice-total">
              <p>{(
                Number(invoiceDetails.total_price)
              ).toLocaleString("fa-IR")}</p>
            </div>

          </div>
        </div> */}


      </div>

      {/* Footer */}
      <div className="footer">
        <div>
          {invoiceDetails.company} · {invoiceDetails.website}
        </div>
        <div style={{ marginTop: 6 }}>{invoiceDetails.contact}</div>
      </div>
    </div >
  );
};

export default Invoice;


